import { PricingCardData } from "../types";

export const pricingData: PricingCardData[] = [
  {
    title: "Pro Creator",
    badge: "Coming Soon",
    subtitle: "Stay Tuned !",
    ctaText: "Register Interest",
    features: [
      "Webcomics, Graphic Novels and Comics Creation",
      "Versatile Templates & Interactive Panels",
      "Collaborative Opportunities",
      "Priority Support",
      "Marketing Boost & Creative Workshops",
    ],
  },
  {
    title: "Pre Launch Rewards",
    badge: "Popular",
    price: "$20",
    originalPrice: "$45",
    savings: "Save 55%",
    ctaText: "Claim Now !",
    features: [
      "Get Double Credits to Kickstart Your Story",
      "Exclusive Early Access to the Platform",
      "Custom Limited-Edition Digital Avatars",
      "VIP Community Status",
      "Private Community Hangouts",
      "Early Bird Discount on Premium Subscriptions",
      "Priority Customer Support",
    ],
    special: true,
  },
  {
    title: "Master Artist",
    badge: "Coming Soon",
    subtitle: "Stay Tuned !",
    ctaText: "Register Interest",
    features: [
      "Everything in the Pro Creator Pack plus:",
      "Unlimited Access to all executive features, assets, and tools",
      "VIP Community Engagement",
      "Priority Exhibition",
      "Monetization Opportunities",
    ],
  },
];
